var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStripe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 200,
    viewBox: "0 0 481 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.641 103.338C480.641 69.1592 464.085 42.1899 432.443 42.1899C400.668 42.1899 381.442 69.1592 381.442 103.071C381.442 143.258 404.139 163.552 436.716 163.552C452.603 163.552 464.619 159.947 473.698 154.874V128.171C464.619 132.711 454.206 135.514 440.988 135.514C428.037 135.514 416.555 130.975 415.087 115.221H480.374C480.374 113.485 480.641 106.542 480.641 103.338ZM414.686 90.6546C414.686 75.5678 423.898 69.2928 432.31 69.2928C440.454 69.2928 449.132 75.5678 449.132 90.6546H414.686Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.907 42.1899C316.822 42.1899 308.411 48.3315 303.738 52.6038L302.003 44.3261H272.63V200L306.008 192.924L306.142 155.141C310.948 158.612 318.024 163.552 329.773 163.552C353.672 163.552 375.434 144.326 375.434 102.003C375.3 63.2847 353.271 42.1899 329.907 42.1899ZM321.896 134.179C314.019 134.179 309.346 131.376 306.142 127.904L306.008 78.3715C309.479 74.4997 314.286 71.8295 321.896 71.8295C334.045 71.8295 342.457 85.4476 342.457 102.938C342.457 120.828 334.179 134.179 321.896 134.179Z",
    fill: "#635BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.702 34.3124L260.214 27.1028V0L226.702 7.0761V34.3124Z",
    fill: "#635BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.214 44.459H226.702V161.281H260.214V44.459Z",
    fill: "#635BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.788 54.339L188.652 44.4592H159.813V161.282H193.191V82.1093C201.068 71.829 214.419 73.6981 218.558 75.1668V44.4592C214.286 42.857 198.665 39.9198 190.788 54.339Z",
    fill: "#635BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.032 15.4873L91.4553 22.4299L91.3218 129.372C91.3218 149.132 106.142 163.685 125.901 163.685C136.849 163.685 144.86 161.682 149.266 159.279V132.176C144.993 133.912 123.899 140.053 123.899 120.294V72.8972H149.266V44.4593H123.899L124.032 15.4873Z",
    fill: "#635BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7784 78.3715C33.7784 73.1646 38.0507 71.1619 45.1268 71.1619C55.2737 71.1619 68.0908 74.2327 78.2376 79.7066V48.3315C67.1562 43.9256 56.2083 42.1899 45.1268 42.1899C18.024 42.1899 0 56.3421 0 79.9737C0 116.823 50.7343 110.948 50.7343 126.836C50.7343 132.978 45.3939 134.98 37.9172 134.98C26.8358 134.98 12.6836 130.441 1.46862 124.299V156.075C13.8852 161.416 26.4352 163.685 37.9172 163.685C65.6876 163.685 84.7797 149.934 84.7797 126.035C84.6462 86.2487 33.7784 93.3248 33.7784 78.3715Z",
    fill: "#635BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.e1754853d0654b3afa0cee87e5997a8e.svg";
export { ForwardRef as ReactComponent };